import { render } from "./CardDivisorioGrigio.vue?vue&type=template&id=1e919a6e&ts=true"
import script from "./CardDivisorioGrigio.vue?vue&type=script&lang=ts"
export * from "./CardDivisorioGrigio.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__